import React, { useEffect, useMemo, useState } from "react";
import GlobalStyles from "@mui/material/GlobalStyles";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  BooleanField,
  FunctionField,
  TopToolbar,
  ExportButton,
  TextInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  useRecordContext,
  useNotify,
  useRefresh,
} from "react-admin";


import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Checkbox,
  Stack,
  TextField as MuiTextField,
  Box,
  Paper,
  Divider,
} from "@mui/material";
import { useListContext } from "react-admin";


import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/* ======================================================
   🌍 DİL METİNLERİ (TR / EN / DE)
====================================================== */
const T = {
  tr: {
    listTitle: "👥 Kullanıcılar",
    exportBtn: "Dışa Aktar",
    search: "Ara",
    role: "Rol",
    status: "Durum",
    active: "Aktif",
    passive: "Pasif",

    name: "Ad Soyad",
    email: "E-posta",
    roleCol: "Rol",
    isActive: "Aktif mi?",
    createdAt: "Oluşturma",
    lastLogin: "Son Giriş",
 selected: "Seçilen dosya",
  noFile: "Dosya seçilmedi",
delete: "Sil",
confirmDelete: "Bu kullanıcı silinsin mi?",
deleted: "Kullanıcı silindi",

    commCenter: "İletişim Merkezi",
    bulkTitle: "Seçili Kullanıcılara Mesaj / Evrak Gönder",
    subject: "Başlık",
    message: "Mesaj",
    file: "Dosya (Resim / PDF / Word)",
    send: "Gönder",
    selectWarning: "Lütfen en az 1 kullanıcı seçin",
    queued: "Gönderim kuyruğa alındı",

    detailsTitle: "Kullanıcı Detayı",
  },
  en: {
    listTitle: "👥 Users",
    exportBtn: "Export",
    search: "Search",
    role: "Role",
    status: "Status",
    active: "Active",
    passive: "Inactive",

    name: "Full Name",
    email: "Email",
    roleCol: "Role",
    isActive: "Active?",
    createdAt: "Created",
    lastLogin: "Last Login",
 selected: "Selected file",
  noFile: "No file selected",
delete: "Delete",
confirmDelete: "Delete this user?",
deleted: "User deleted",


    commCenter: "Communication Center",
    bulkTitle: "Send Message / Document to Selected Users",
    subject: "Subject",
    message: "Message",
    file: "File (Image / PDF / Word)",
    send: "Send",
    selectWarning: "Please select at least 1 user",
    queued: "Send queued",

    detailsTitle: "User Details",
  },
  de: {
    listTitle: "👥 Benutzer",
    exportBtn: "Exportieren",
    search: "Suchen",
    role: "Rolle",
    status: "Status",
    active: "Aktiv",
    passive: "Inaktiv",

    name: "Name",
    email: "E-Mail",
    roleCol: "Rolle",
    isActive: "Aktiv?",
    createdAt: "Erstellt",
    lastLogin: "Letzte Anmeldung",
 selected: "Ausgewählte Datei",
  noFile: "Keine Datei ausgewählt",
delete: "Löschen",
confirmDelete: "Benutzer löschen?",
deleted: "Benutzer gelöscht",

    commCenter: "Kommunikationszentrale",
    bulkTitle: "Nachricht / Dokument an ausgewählte Benutzer senden",
    subject: "Betreff",
    message: "Nachricht",
    file: "Datei (Bild / PDF / Word)",
    send: "Senden",
    selectWarning: "Bitte mindestens 1 Benutzer auswählen",
    queued: "Senden vorgemerkt",

    detailsTitle: "Benutzerdetails",
  },
};

const ALLOWED = ["tr", "en", "de"];
function useUiTexts() {
  const [uiLang, setUiLang] = useState(() => {
    const l = (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase();
    return ALLOWED.includes(l) ? l : "tr";
  });

  useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);

  return T[ALLOWED.includes(uiLang) ? uiLang : "tr"];
}

/* ======================================================
   🔧 YARDIMCILAR (MEVCUT TABLO UYUMLU)
====================================================== */
const pick = (r, keys) =>
  keys.map((k) => r?.[k]).find((v) => v !== undefined && v !== null && v !== "");

const fullName = (r) =>
  pick(r, ["ad_soyad", "full_name"]) ||
  [pick(r, ["ad", "first_name"]), pick(r, ["soyad", "last_name"])]
    .filter(Boolean)
    .join(" ") ||
  "-";

const createdFrom = (r) => pick(r, ["created_at", "createdAt", "created"]);
const lastLoginFrom = (r) => pick(r, ["last_login", "lastLogin", "son_giris"]);

/* ======================================================
   🔝 ÜST BAR
====================================================== */
const ListActions = () => {
  const TT = useUiTexts();
  return (
    <TopToolbar sx={{ justifyContent: "flex-end" }}>
      <ExportButton label={TT.exportBtn} />
    </TopToolbar>
  );
};


/* ======================================================
   🗑️ SİLME BUTONU (DİLLİ)
====================================================== */
const DeleteUserButton = ({ record }) => {
  const TT = useUiTexts();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleDelete = async () => {
    if (!window.confirm(TT.confirmDelete)) return;

    try {
      const res = await fetch(`/api/kullanicilar/${record.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!res.ok) throw new Error();

      notify(TT.deleted, { type: "success" });
      refresh();
    } catch {
      notify(TT.error || "Hata oluştu", { type: "error" });
    }
  };

  return (
    <Button
      color="error"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        handleDelete();
      }}
    >
      {TT.delete}
    </Button>
  );
};
const SelectAllCheckbox = ({ selectedIds, setSelectedIds }) => {
  const { data } = useListContext();

  if (!data || data.length === 0) return null;

  const allSelected = selectedIds.length === data.length;
  const partial =
    selectedIds.length > 0 && selectedIds.length < data.length;

  return (
  <Checkbox
  checked={allSelected}
  indeterminate={partial}
  onChange={() => {
  setSelectedIds((prev) => {
    if (prev.length === data.length) {
      return [];
    }
    return data.map((r) => r.id);
  });
}}

/>

  );
};





/* ======================================================
   🏢 KURUMSAL AKORDEON — TEK FORM / ÇOKLU KULLANICI
====================================================== */
const IletisimAkordiyon = ({ selectedIds, clearSelection }) => {
  const TT = useUiTexts();
  const notify = useNotify();

  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);

const handleSend = async () => {
  if (!selectedIds?.length) {
    notify(TT.selectWarning, { type: "warning" });
    return;
  }

  const uiLang = (localStorage.getItem("app_lang") || "tr")
    .slice(0, 2)
    .toLowerCase();

  const formData = new FormData();
  formData.append("baslik", subject);
  formData.append("mesaj", message);
  formData.append("alici_ids", JSON.stringify(selectedIds));
  formData.append("language", uiLang);

  if (file) {
    formData.append("dosyalar", file); // ✅ KRİTİK SATIR
  }

  await fetch("/api/mesajlar", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: formData,
  });

  notify(`${TT.queued} (${selectedIds.length})`, { type: "success" });

  setSubject("");
  setMessage("");
  setFile(null);
  clearSelection?.();
};


  return (
    <Paper elevation={2} sx={{ mb: 2, borderRadius: 2 }}>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box sx={{ width: "100%" }}>
            <Typography fontWeight={900}>{TT.commCenter}</Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              {TT.bulkTitle}{" "}
              <b>{selectedIds?.length ? `(${selectedIds.length})` : ""}</b>
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2}>
            <MuiTextField
              label={TT.subject}
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              fullWidth
            />

            <MuiTextField
              label={TT.message}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              multiline
              minRows={4}
              fullWidth
            />

            <Divider />

            <Box>
              <Typography variant="body2" fontWeight={700} sx={{ mb: 1 }}>
                {TT.file}
              </Typography>

      <input
  type="file"
  accept="image/*,.pdf,.doc,.docx"
  onChange={(e) => setFile(e.target.files?.[0] || null)}
/>

{file ? (
  <Typography
    variant="caption"
    sx={{ display: "block", mt: 1, opacity: 0.8 }}
  >
    {TT.selected}: <b>{file.name}</b>
  </Typography>
) : (
  <Typography
    variant="caption"
    sx={{ display: "block", mt: 1, opacity: 0.5 }}
  >
    {TT.noFile}
  </Typography>
)}

            </Box>

            <Button variant="contained" size="large" onClick={handleSend}>
              {TT.send}
            </Button>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

/* ======================================================
   📄 LISTE (APP.JS UYUMLU)
====================================================== */
function KullanicilarPage(props) {
  const TT = useUiTexts();
  const [selectedIds, setSelectedIds] = useState([]);

  const filters = useMemo(
    () => [
      <TextInput key="q" source="q" label={TT.search} alwaysOn />,
      <SelectInput
        key="rol"
        source="rol"
        label={TT.role}
        choices={[
          { id: "admin", name: "Admin" },
          { id: "editor", name: "Editor" },
          { id: "user", name: "User" },
          { id: "kurum", name: "Kurum" },
          { id: "kullanici", name: "Kullanıcı" },
        ]}
        emptyText="—"
      />,
      <SelectInput
        key="aktif"
        source="aktif"
        label={TT.status}
        choices={[
          { id: true, name: TT.active },
          { id: false, name: TT.passive },
        ]}
        emptyText="—"
      />,
    ],
    [TT]
  );

  const clearSelection = () => setSelectedIds([]);

  return (
    <>
      <GlobalStyles
        styles={{
          ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
        }}
      />
<List
  {...props}
  title={TT.listTitle}
  filters={filters}
  actions={<ListActions />}
  perPage={25}
  sort={{ field: "created_at", order: "DESC" }}
>




        {/* Kurumsal iletişim merkezi */}
        <IletisimAkordiyon selectedIds={selectedIds} clearSelection={clearSelection} />

<Datagrid
  bulkActionButtons={false}
  rowClick={false}
  sx={{ "& .RaDatagrid-headerCell": { fontWeight: 900 } }}
>


  {/* ✔ seçim checkbox */}
<FunctionField
  label={
    <SelectAllCheckbox
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
    />
  }
  render={(r) => (
    <Checkbox
      checked={selectedIds.includes(r.id)}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) =>
        setSelectedIds((prev) =>
          e.target.checked
            ? [...prev, r.id]
            : prev.filter((x) => x !== r.id)
        )
      }
    />
  )}
/>


  {/* ✔ ad soyad */}
  <FunctionField
    label={TT.name}
    render={(r) => (
      <span style={{ fontWeight: 600 }}>
        {fullName(r)}
      </span>
    )}
  />

  {/* ✔ email */}
  <EmailField source="email" label={TT.email} />

  {/* ✔ rol */}
<FunctionField
  label={TT.roleCol}
  render={(r) => {
    const map = {
      admin: "Admin",
      editor: "Editor",
      user: "User",
      kurum: "Kurum",
      kullanici: "Kullanıcı",
    };
    return map[r.rol] || "-";
  }}
/>

  {/* ✔ aktif mi */}
  <BooleanField source="aktif" label={TT.isActive} />

  {/* ✔ oluşturma tarihi */}
  <FunctionField
    label={TT.createdAt}
    render={(r) => {
      const v = createdFrom(r);
      return v ? String(v).slice(0, 10) : "-";
    }}
  />

  {/* ✔ son giriş */}
  <FunctionField
    label={TT.lastLogin}
    render={(r) => {
      const v = lastLoginFrom(r);
      return v ? String(v).replace("T", " ").slice(0, 16) : "-";
    }}
  />

  {/* 🔥 SİL BUTONU (İŞTE ARADIĞIN YER) */}
  <FunctionField
    label=""
    render={(record) => <DeleteUserButton record={record} />}
  />

</Datagrid>

      </List>
    </>
  );
}


/* ======================================================
   📄 SHOW (DETAY) — KULLANICIYA TIKLAYINCA HATA ATMASIN
====================================================== */
function KullaniciShow(props) {
  const TT = useUiTexts();

  // Record bazen ilk render’da null gelebiliyor, patlamasın:
  const SafeName = () => {
    const r = useRecordContext();
    return <span>{r ? fullName(r) : "-"}</span>;
  };

  const SafeCreated = () => {
    const r = useRecordContext();
    const v = r ? createdFrom(r) : null;
    return <span>{v ? String(v).slice(0, 10) : "-"}</span>;
  };

  const SafeLastLogin = () => {
    const r = useRecordContext();
    const v = r ? lastLoginFrom(r) : null;
    return <span>{v ? String(v).replace("T", " ").slice(0, 16) : "-"}</span>;
  };

  return (
    <>
      <GlobalStyles
        styles={{
          ".RaNotification-content": { fontSize: "1.05rem", fontWeight: 800 },
        }}
      />
      <Show {...props} title={TT.detailsTitle}>
        <SimpleShowLayout>
          <FunctionField label={TT.name} render={() => <SafeName />} />
          <EmailField source="email" label={TT.email} />
          <TextField source="rol" label={TT.roleCol} />
          <BooleanField source="aktif" label={TT.isActive} />
          <FunctionField label={TT.createdAt} render={() => <SafeCreated />} />
          <FunctionField label={TT.lastLogin} render={() => <SafeLastLogin />} />
        </SimpleShowLayout>
      </Show>
    </>
  );
}

/* ======================================================
   🔚 EXPORTLAR (APP.JS UYUMLU)
====================================================== */
export default KullanicilarPage;
export { KullanicilarPage, KullaniciShow };
